export const tagsHd = [
    // {label:'ID', sortOption: '', id: null},
    {label:'Tag Name', sortOption: '', id: null},
    {label:'Created By', sortOption: '', id: null},
    {label:'Created At', sortOption: '', id: null},
    {label:'Modified At', sortOption: '', id: null},
    {label:'Action(s)', sortOption: '', id: null},
  ];